import { useMutation } from '@tanstack/react-query';
import { previewChangePlan } from '@/services/subscription.service';
import type { BillingCycle, ChangePlanPreviewDto } from '@/types/subscription';

export interface PreviewChangePlanArgs {
    planCode: string;
    billingCycle?: BillingCycle;
}

/**
 * 플랜 변경 미리보기 — 다이얼로그 열 때 mutate({ planCode, billingCycle })로 호출.
 */
export const useChangePlanPreview = () => {
    return useMutation<ChangePlanPreviewDto, unknown, PreviewChangePlanArgs>({
        mutationFn: ({ planCode, billingCycle }) => previewChangePlan(planCode, billingCycle),
    });
};
